var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 8.44772 14.4477 8 15 8H17C17.5523 8 18 8.44772 18 9H20.5C20.7761 9 21 9.22386 21 9.5C21 9.77614 20.7761 10 20.5 10H11.5C11.2239 10 11 9.77614 11 9.5C11 9.22386 11.2239 9 11.5 9H14Z",
    fill: "#00112A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16C14.7761 16 15 16.2239 15 16.5V19.5C15 19.7761 14.7761 20 14.5 20C14.2239 20 14 19.7761 14 19.5V16.5C14 16.2239 14.2239 16 14.5 16Z",
    fill: "#00112A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20C17.7761 20 18 19.7761 18 19.5V16.5C18 16.2239 17.7761 16 17.5 16C17.2239 16 17 16.2239 17 16.5V19.5C17 19.7761 17.2239 20 17.5 20Z",
    fill: "#00112A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13C10 11.8954 10.8954 11 12 11H20C21.1046 11 22 11.8954 22 13L21 22C21 23.1046 20.1046 24 19 24H13C11.8954 24 11 23.1046 11 22L10 13ZM20 12C20.5523 12 21 12.4477 21 13L20 22C20 22.5523 19.5523 23 19 23H13C12.4477 23 12 22.5523 12 22L11 13C11 12.4477 11.4477 12 12 12H20Z",
    fill: "#00112A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c1d68b095a5de1f9727e4de61ab3a2f5.svg";
export { ForwardRef as ReactComponent };